import { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { Dialog, DialogContent } from "@mui/material";
import { VerticalCounter } from "./VerticalCounter";
import { useEffect } from "react";
import moment from "moment";

export const DigitalClock = (props) => {
  const { date, onClose, onSave, open, onAlert } = props;
  const [hour, setHour] = useState(12);
  const [minutes, setMinutes] = useState(0);
  const [timePeriod, setTimePeriod] = useState("am");
  const [minHour, setMinHour] = useState("am");
  const [minMinutes, setMinMinutes] = useState("am");
  const [currentTimePeriod, setCurrentTimePeriod] = useState("am");

  const handleHourIncrease = () => {
    if (hour === 12) {
      setHour(1);
      handleTimePeriod();
    } else {
      setHour(hour + 1);
    }
  };

  const handleHourDecrease = () => {
    if (hour === 1) {
      setHour(12);
      handleTimePeriod();
    } else {
      setHour(hour - 1);
    }
  };

  const handleMinuteIncrease = () => {
    if (minutes === 59) {
      setMinutes(0);
      handleHourIncrease();
    } else {
      setMinutes(minutes + 1);
    }
  };

  const handleMinuteDecrease = () => {
    if (minutes === 0) {
      setMinutes(59);
      handleHourDecrease();
    } else {
      setMinutes(minutes - 1);
    }
  };

  const handleTimePeriod = () => {
    if (timePeriod === "am") {
      setTimePeriod("pm");
    } else {
      if (currentTimePeriod != "pm") setTimePeriod("am");
    }
  };

  const handleSave = () => {
    //const currentTime = date.toLocaleDateString();
    const newTimeString = `${date.getFullYear()}-${
      date.getMonth() + 1
    }-${date.getDate()} ${hour}:${minutes
      .toString()
      .padStart(2, "0")}:00 ${timePeriod}`;
    //const newValue = Date.parse(newTimeString);
    const newTimeDate = new Date(newTimeString);
    onSave(newTimeDate);
  };

  useEffect(() => {
    let currentHour = date.getHours();
    let currentMinutes = date.getMinutes();
    let currentPeriod = currentHour >= 12 ? "pm" : "am";
    currentHour = currentHour % 12;
    currentHour = currentHour ? currentHour : 12;
    setMinHour(currentHour);
    setMinMinutes(currentMinutes);
    setCurrentTimePeriod(currentPeriod);
    setHour(currentHour);
    setMinutes(currentMinutes);
    setTimePeriod(currentPeriod);
  }, []);

  return (
    <div>
      <Dialog open={open}>
        <DialogContent>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <VerticalCounter
              value={hour.toString().padStart(2, "0")}
              onIncrease={() => handleHourIncrease()}
              onDecrease={() => handleHourDecrease()}
            />
            <VerticalCounter
              value={minutes.toString().padStart(2, "0")}
              onIncrease={() => handleMinuteIncrease()}
              onDecrease={() => handleMinuteDecrease()}
            />
            <VerticalCounter
              value={timePeriod}
              onIncrease={() => handleTimePeriod()}
              onDecrease={() => handleTimePeriod()}
            />
          </Box>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Button color="error" onClick={() => onClose()}>
              Cancel
            </Button>
            <Button onClick={handleSave}>Save</Button>
          </Box>
        </DialogContent>
      </Dialog>
    </div>
  );
};
